import React from 'react';
import PropTypes from 'prop-types';
import styles from './HighlightTitleForPublisherPackage.scss';
import OMLabelTop from '../OMComponents/OMLabelTop/OMLabelTop';

const HighlightTitleForPublisherPackage = (props) => {
  const { haveHighlight, haveAutojump, haveTopPromotion } = props;

  if (!haveHighlight && !haveAutojump && !haveTopPromotion) { return null; }

  const autoJump = haveAutojump && (
    <span className="icon icon-auto-jump-active" >
      <i className="path1" />
      <i className="path2" />
      <i className="path3" />
    </span>
    );
  const highlight = haveHighlight && (
    <span className="icon icon-promoted-active" >
      <i className="path1" />
      <i className="path2" />
      <i className="path3" />
    </span>
    );
  const topPromotion = haveTopPromotion && (
    <OMLabelTop
      label="TOP"
      title="TOP"
    />
  );
  const separator = haveHighlight && (<span>&nbsp;+&nbsp;</span>);

  return (
    <div className={styles.wrapper}>
      {topPromotion}
      {autoJump}
      {separator}
      {highlight}
    </div>
  );
};

HighlightTitleForPublisherPackage.propTypes = {
  haveHighlight: PropTypes.bool,
  haveTopPromotion: PropTypes.bool,
  haveAutojump: PropTypes.bool,
  topPromotionLabel: PropTypes.string
};

export default HighlightTitleForPublisherPackage;
